module.exports = __webpack_public_path__ + "img/1588436662.039b9a30.jpg";